import Vue from 'vue';
import {Scrollbar, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue')
    },
    el,
    data: () => ({
      swiper: null,
      swiperOptions: {
        modules: [Scrollbar, A11y, Keyboard],
        slidesPerView: 1.38,
        a11y: true,
        keyboard: true,
        spaceBetween: 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 12
          }
        }
      }
    }),
  });
